<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="main">
			<div class="desc-box">
				<div class="section-wrap">
          <div class="text">
            <div class="p">2026 戴尔科技峰会暨「进化者」论坛将在上海及 3 个卫星城市 北京 / 广州 / 青岛 同时开启线下创新之旅！</div>
            <div class="p">本届峰会聚焦企业级 AI 从 “技术探索期” 迈向 “规模应用与价值兑现期” 的关键节点，探讨中国企业在全球化深水区面临的数字化转型挑战与破局路径。将从推动 AI 落地见效、重构成本模型、打造 AI 原生工作方式、构建可信智能体系、夯实全球化数字化底座五大维度。与来自各行业的领军企业决策者与技术领袖，共同洞察AI驱动下的更优「进化路径」，把握下一阶段增长的主动权。</div>
          </div>
					<div class="video">
						<div class="poster" >
							<video controls id="s1_video" class="video" :controls="!s1_play_show" :poster="require('@/assets/image/2022/20220803001_video.jpg')" loop @click.prevent="stopVideo" src="https://dellvideo.smarket.net.cn/045f032b2e9243b699ae5160993b071d/2bafcc4ed54144998bc02edb775f8aa0-1aa1e196881414ebcb3e345daf76fdf5-ld.mp4"></video>
							<div class="play" v-if="s1_play_show" @click="playVideo"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="city-box">
				<div class="section-wrap">
					<div class="swiper-container" id="swiper-city">
						<div class="swiper-wrapper">
							<div class="swiper-slide" :class="[city_choose.id === item.id ? 'active' : '']" v-for="(item,index) in city" :key="index" @click="changeCity(item)">
								<div class="image">
									<img class="icon" :src="util.autoImage(item.icon)" alt="">
									<img class="icon active" :src="util.autoImage(item.icon_active)" alt="">
								</div>
								<div class="tit">{{ item.title }}</div>
							</div>
						</div>
					</div>
					<div class="prev"></div>
					<div class="next"></div>
				</div>
			</div>
			<div class="content-box" v-if="city_choose.id">
				<div class="section-wrap">
					<div class="item">
						<div class="title-box">
							<div class="title">酒店导览</div>
						</div>
						<div class="con con-1">
							<div class="map">
								<lbs :detail="city_choose"/>
							</div>
							<div class="info">
								<div class="wrap">
									<div class="title">{{ city_choose.hotel_title }}</div>
									<div class="li">
										<div class="icon icon-address"></div>
										<div class="about">
											<div class="tit">地址</div>
											<div class="text">{{city_choose.hotel_address}}</div>
										</div>
									</div>
									<div class="li">
										<div class="icon icon-tel"></div>
										<div class="about">
											<div class="tit">联系电话</div>
											<div class="text">{{city_choose.hotel_tel}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="item" style="display: none">
						<div class="title-box">
							<div class="title">防疫要求</div>
						</div>
						<div class="con con-2">
							<div class="text" v-html="city_choose.epidemic_rule"></div>
						</div>
					</div>
					<div class="item" style="display: none">
						<div class="title-box">
							<div class="title">入场须知</div>
						</div>
						<div class="con con-3">
							<div class="text" v-html="city_choose.enter_rule"></div>
						</div>
					</div>
				</div>
				<sponsor/>
			</div>
		</div>
	</main>
</template>

<script>
import Crumbs from "../../components/pc/Crumbs";
import Loading from "../../components/pc/Loading";
import Lbs from "../../components/pc/Lbs";
import Sponsor from "@/components/pc/Sponsor.vue";
export default {
	name: 'offline',
	data() {
		return {
			city:[],
			city_choose:{},
			s1_play_show:true,
		}
	},
	components:{Crumbs,Loading,Lbs,Sponsor},
	computed:{
		crumbs() {
			return {title:"线下活动",min_title:"OFFLINE EVENTS"}
		},

	},
	methods: {
		playVideo(id){
			var video = document.getElementById('s1_video');
			this.s1_play_show = false;
			video.play();
		},
		stopVideo(id){
			var video = document.getElementById('s1_video');
			this.s1_play_show = true;
			video.pause();
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-city',{
				slidesPerView:4,
				slidesPerGroup:4,
				spaceBetween: 25,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
				navigation: {
					nextEl: ".section-wrap .next",
					prevEl: ".section-wrap .prev",
				},
			})
		},
		changeCity(item){
			this.city_choose = item;
		},
		getCity(){
			this.http.request({
				api: "offline/getCity",
				success:(res)=>{
					this.city = res.list;
					this.changeCity(this.city[0]);
				}
			})
		}
	},
	mounted() {
		this.getCity();
		this.swiperInit();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.main{
	.desc-box{padding: 70px 0;background: #F2F2F2;position: relative;
		.section-wrap{width: 1200px;margin: 0 auto;position: relative;z-index: 2;
			.text{font-size: 16px;line-height: 24px;color:#444;
				.p{margin-bottom: 10px;}
			}
			.video{display: none;
				.poster{width: 960px;height:540px;margin: 30px auto 0;background: #000;position: relative;
					.video{width: 100%;height:100%;object-fit: contain;display:block;}
					.play{position: absolute;top:50%;left:50%;margin-left: -39px;margin-top: -39px; width: 78px;height:78px;background:url("~@/assets/image/2022/7.png") no-repeat center center;background-size: contain;cursor: pointer;}
				}
			}
		}
	}
	.desc-box::before{content: "";display: block;position: absolute;top:50%;right:0;transform: translateY(-50%);width: 136px;height:126px;background: url("~@/assets/image/2022/6.png") no-repeat center center;background-size: contain;}
	.city-box{padding-top: 70px;
		.section-wrap{width: 1200px;margin: 0 auto;position: relative;
			.swiper-container{
				.swiper-wrapper{
					.swiper-slide{cursor: pointer;
						.image{width: 150px;height:192px;margin: 0 auto;position: relative;display: flex;padding:30px 20px 10px;align-items: flex-end;background: url("~@/assets/image/2022/8.png") no-repeat bottom center;background-size: contain;box-sizing: border-box;
							.icon{display:block;max-width: 100%;max-height: 100%;object-fit:contain;}
							.icon.active{display: none;}
						}
						.tit{margin-top: 20px;text-align:center;font-size: 18px;font-weight: bold;}
					}
					.swiper-slide.active{
						.image{background-image: url("~@/assets/image/2022/9.png");background-size: contain;
							.icon{display: none;}
							.icon.active{display: block;}
						}
					}
				}
			}
			.prev,.next{width: 42px;height:42px;background: rgba(0,0,0,.1);border-radius: 50%;position: absolute; top:100px;z-index: 2;display: flex;align-items: center;justify-content: center;cursor: pointer;}
			.prev::after,.next::after{content: "";display: block;width: .14rem;height:.14rem;border:2px solid #0672cb;border-left: 0;border-bottom: 0;transform: rotate(45deg)}
			.prev{left:0;transform: translate(-50%,-50%);}
			.prev::after{transform: rotate(225deg);}
			.next{right:0;transform: translate(50%,-50%);}
			.prev.swiper-button-disabled::after,.next.swiper-button-disabled::after{border-color: #fff;}
		}
	}
	.content-box{margin-top: 50px;padding-bottom: 100px;position: relative;
		.section-wrap{margin: 0 auto;width: 1200px;
			.item{margin-bottom: 30px;
				.title-box{
					.title{font-size: 32px;color:#0672cb;position: relative;line-height: 1;display: inline-block;}
					.title::after{content: "";display: block;width: 40px;height:4px;background: linear-gradient(to left,rgba(55,111,132, 0),#0672cb);position: absolute;bottom:0;right:-8px;transform: translateX(100%)}
				}
				.con{margin-top: 20px;
					.text{font-size: 16px;line-height: 24px;color:#444;
						.p{margin-bottom: 10px;}
					}
				}
				.con-1{display: flex;
					.map{width: 60%;height:408px;position: relative}
					.info{flex: 1;background: rgba(251, 251, 251, 1);border: 1px solid rgba(241, 241, 241, 1);display: flex;align-items:center;padding: 0 60px;
						.title{font-size: 18px;font-weight: bold;color:#444444;}
						.li{margin-top: 20px;display: flex;
							.icon{width: 22px;height:22px;}
							.icon.icon-address{width: 17px; background: url("~@/assets/image/2022/4.png") no-repeat left center;background-size: contain;}
							.icon.icon-tel{width: 21px; height:21px; background: url("~@/assets/image/2022/5.png") no-repeat left center;background-size: contain;}
							.about{flex: 1;font-size: 16px;color:#444;margin-left: 10px;
								.tit{font-weight: bold;line-height: 22px;}
								.text{margin-top: 5px;}
							}
						}
					}
				}
			}
			.item:nth-last-child(1){margin-bottom: 0;}
		}
	}
	.content-box::after{content: "";display: block;position: absolute;bottom:0;left:0;width: 100%;height: 100%;pointer-events: none;}
}
</style>

